import { Fieldset } from 'foundations-components/transitional/components/Fieldset';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LegendWrapper = styled.div.withConfig({
  displayName: "EditorUIFieldSet__LegendWrapper",
  componentId: "xrbxhw-0"
})(({
  theme
}) => ({
  marginBottom: theme.space[200],
  wordWrap: 'break-word',
  marginRight: '80px'
}));
const EditorUIFieldSet = props => {
  const {
    children,
    legend,
    isRefinement = false
  } = props;
  return /*#__PURE__*/_jsxs(Fieldset, {
    _size: "small",
    children: [!isRefinement && /*#__PURE__*/_jsx(LegendWrapper, {
      children: /*#__PURE__*/_jsx("strong", {
        children: legend
      })
    }), children]
  });
};
export default EditorUIFieldSet;